import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "../src/pages/home/Home";
import Blog from "./pages/blogs/Blog";
import BlogView from "./pages/blogs/BlogView";
import NewsUpdatesPage from "./pages/resources/NewsUpdatesPage";
import AboutUsMain from "./pages/aboutus/AboutUsMain";
import { css } from "@emotion/react";
import PropagateLoader from "react-spinners/PropagateLoader";
import Countries from "./pages/Explore/countries";
import NewsDetails from "./pages/resources/NewsDetails";
import WOW from "wowjs";
import BookCounselling from "./pages/book counselling/BookCounselling";
import TermsAndConditions from "./pages/TermsAndConditions";
import RefundPage from "./pages/RefundPage";
import PrivacyPage from "./pages/PrivacyPage";
import ContactUsPage from "./pages/ContactUsPage";
import CounsellingReadMoreSection from "./pages/home/CounsellingReadMoreSection";
import ImmigrationReadMoreSection from "./pages/home/ImmigrationReadMoreSection";
import EducationLoanAssistanceSection from "./pages/home/EducationLoanAssistanceSection";
import CounsellingMainPage from "./pages/home/CounsellingMainPage";
import ImmigrationMainPage from "./pages/home/ImmigrationMainPage";
import EducationLoanMainPage from "./pages/home/EducationLoanMainPage";
import ScrollToTop from "./components/ScrollToTop";
import InterestedSectionMain from "./components/interested section/InterestedSectionMain";
import Conclave from "./pages/conclave page/Conclave";
import AgendaPage from "./pages/conclave page/AgendaPage";

function App() {
  const override = css`
    position: absolute;
    left: 50%;
    right: 50%;
    top: 50%;
    bottom: 50%;
  `;
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 2200);
  // }, []);

  return (
    <>
      {loading ? (
        <PropagateLoader
          color={"var(--theme-red)"}
          css={override}
          loading={loading}
          size={30}
        />
      ) : (
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Conclave" element={<Conclave />} />
            <Route path="/AgendaPage" element={<AgendaPage />} />
            <Route
              path="/InterestedSectionMain"
              element={<InterestedSectionMain />}
            />
            <Route
              path="/ImmigrationMainPage"
              element={<ImmigrationMainPage />}
            />

            <Route
              path="/EducationLoanMainPage"
              element={<EducationLoanMainPage />}
            />
            <Route
              path="/CounsellingMainPage"
              element={<CounsellingMainPage />}
            />
            <Route
              path="/EducationLoanAssistanceSection"
              element={<EducationLoanAssistanceSection />}
            />
            <Route
              path="/ImmigrationReadMoreSection"
              element={<ImmigrationReadMoreSection />}
            />

            <Route path="/Home" element={<Home />} />
            <Route path="/Countries" element={<Countries />} />
            <Route path="/Blog" element={<Blog />} />
            <Route path="/BlogView" element={<BlogView />} />
            <Route path="/AboutUsMain" element={<AboutUsMain />} />
            <Route path="/NewsDetails" element={<NewsDetails />} />
            <Route
              path="/CounsellingReadMoreSection"
              element={<CounsellingReadMoreSection />}
            />
            <Route
              path="/TermsAndConditions"
              element={<TermsAndConditions />}
            />
            <Route path="/ContactUsPage" element={<ContactUsPage />} />
            <Route path="/RefundPage" element={<RefundPage />} />
            <Route path="/PrivacyPage" element={<PrivacyPage />} />
            <Route path="/BookCounselling" element={<BookCounselling />} />

            <Route path="/NewsUpdatesPage" element={<NewsUpdatesPage />} />
            {/* <Route path="/" element={<Navigate to="/Home" replace />} /> */}
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
}

export default App;
